import { connectFirestoreEmulator, getFirestore, type Firestore } from 'firebase/firestore';

import { getFirebaseApp } from './app';
import { getFirebaseEnvConfig } from './config';

type FirestoreGlobalState = typeof globalThis & {
  __verdeconfirmaFirestore?: Firestore;
  __verdeconfirmaFirestoreEmulatorConnected?: boolean;
};

const firebaseGlobal = globalThis as FirestoreGlobalState;

export function getFirebaseFirestore(): Firestore {
  if (firebaseGlobal.__verdeconfirmaFirestore) {
    return firebaseGlobal.__verdeconfirmaFirestore;
  }

  const firestore = getFirestore(getFirebaseApp());

  if (getFirebaseEnvConfig().useEmulators && !firebaseGlobal.__verdeconfirmaFirestoreEmulatorConnected) {
    connectFirestoreEmulator(firestore, '127.0.0.1', 8080);
    firebaseGlobal.__verdeconfirmaFirestoreEmulatorConnected = true;
  }

  firebaseGlobal.__verdeconfirmaFirestore = firestore;
  return firestore;
}
